export const globalloaderTokens = {
  globalloader: {
    root: {
      shadow: '0 20px 34px 0 rgba(53, 67, 88, 0.08)',
      borderRadius: '{borderRadius.sm}'
    }
  }
};

export type GlobalLoaderTokens = typeof globalloaderTokens;
